module.exports = __webpack_public_path__ + "img/angel-2.acf63619.webp";